var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlowVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_190_3480)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3337 2.66625C14.07 2.66625 14.6662 3.26375 14.6662 4V12C14.6662 12.7338 14.0662 13.3338 13.3337 13.3338H2.66624C1.93374 13.3338 1.33374 12.7338 1.33374 12V4C1.33374 3.26625 1.93374 2.66625 2.66624 2.66625H3.33374L4.57499 5.14875C4.63124 5.26125 4.74624 5.3325 4.87249 5.3325H6.12749C6.37499 5.3325 6.53624 5.07125 6.42499 4.85L5.57499 3.1475C5.46374 2.92625 5.62499 2.665 5.87249 2.665H6.46124C6.58749 2.665 6.70249 2.73625 6.75874 2.84875L7.90749 5.14625C7.96374 5.25875 8.07999 5.33 8.20624 5.33H9.46124C9.70874 5.33 9.86999 5.06875 9.75874 4.8475L8.90749 3.145C8.79749 2.92375 8.95874 2.6625 9.20624 2.6625H9.79374C9.91999 2.6625 10.0362 2.73375 10.0925 2.84625L11.2412 5.14375C11.2975 5.25625 11.4125 5.3275 11.5387 5.3275H12.7937C13.0412 5.3275 13.2025 5.06625 13.0925 4.845L12.2412 3.1425C12.13 2.92125 12.2912 2.66 12.5387 2.66H13.3337V2.66625ZM4.25249 6.66625C3.99999 6.66625 3.76874 6.52375 3.65624 6.2975L2.66624 4.31375V12H13.3337V6.66625H3.99999H4.25249Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.87352 9.03615L6.21181 8.02127H6.70547L7.04376 9.03615L8.05864 9.37444V9.8681L7.04376 10.2064L6.70547 11.2213H6.21181L5.87352 10.2064L4.85864 9.8681V9.37444L5.87352 9.03615Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7116 8.00054L9.96532 7.23938H10.3356L10.5893 8.00054L11.3504 8.25426V8.6245L10.5893 8.87822L10.3356 9.63938H9.96532L9.7116 8.87822L8.95044 8.6245V8.25426L9.7116 8.00054Z",
    fill: "#161616"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_190_3480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlowVideo);
export default __webpack_public_path__ + "static/media/Slow Video.91e90fd323a426f0d6eb24f15f1a7ac8.svg";
export { ForwardRef as ReactComponent };